import React, { FC, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { SidebarTitle } from '../../../shared/components';
import { ScreenProps } from './DifferentiationsContainer';
import { DifferentiationScreenAction } from './DifferentiationScreenAction';
import { useHistory } from 'react-router';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { DeleteWrapper, DifferentiationsOverviewWrapper, StyledIntro } from './Atoms';
import { BottomBar } from 'src/modules/shared/components/BottomBar/BottomBar';
import { useSnackbar } from 'notistack';

export const DeleteTrajectoryVersion: FC<ScreenProps> = ({
  openCallback,
  bookId,
  chapterId,
  trajectoryId,
  metaData,
}) => {
  const [deleteTrajectoryVersionResponse, deleteTrajectoryVersion] = useFetch('', {
    method: 'DELETE',
  });
  const { t } = useTranslation();
  const history = useHistory();
  const { getPath } = useI18nPath();

  const handleDeleteTrajectoryVersion = useCallback(() => {
    deleteTrajectoryVersion({
      path: apiRoutes.trajectory(metaData.version ? metaData.version.id : ''),
    });
  }, [deleteTrajectoryVersion, metaData]);

  useEffect(() => {
    if (deleteTrajectoryVersionResponse.success) {
      if (metaData.version?.id === trajectoryId && metaData.version.parentId != null) {
        history.push(
          getPath('trajectoryView', {
            bookId,
            chapterId,
            trajectoryId: metaData.version.parentId,
          })
        );
      } else {
        openCallback(DifferentiationScreenAction.OVERVIEW, 'REFETCH');
      }
    }
  }, [
    deleteTrajectoryVersionResponse,
    openCallback,
    metaData,
    history,
    getPath,
    bookId,
    chapterId,
    trajectoryId,
  ]);
  
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (deleteTrajectoryVersionResponse.error) {
      enqueueSnackbar(t('shared.errors.generic'), {
        autoHideDuration: 2000,
        variant: 'error',
        style: { zIndex: '10000 !important' },
      });
    }
  }, [deleteTrajectoryVersionResponse.error, enqueueSnackbar, t]);

  return (
    <DeleteWrapper>
      <DifferentiationsOverviewWrapper>
        <SidebarTitle title={t('differentiations.deleteVersion')} icon={SpriteIconsLight.EDIT} />
        <StyledIntro>{t('differentiations.confirmDeleteVersion')}</StyledIntro>
      </DifferentiationsOverviewWrapper>
      <BottomBar
        icon={SpriteIconsLight.CIRCLE_PLUS}
        submitText={t('shared.delete')}
        hasCancelButton
        submitCallback={handleDeleteTrajectoryVersion}
        cancelCallback={() => openCallback(DifferentiationScreenAction.OVERVIEW)}
        cancelText={t('shared.forms.cancel')}
        disableSubmit={deleteTrajectoryVersionResponse.pending}
        disableCancel={deleteTrajectoryVersionResponse.pending}
      />
    </DeleteWrapper>
  );
};
